(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p03-hello"] && !Shopify.designMode) return;
  try {
    
class P03Video extends HTMLElement {
  static active = null;

  connectedCallback() {
    this.cleanup();
    this.video = this.querySelector('video');
    if (!this.video) return;
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.frame = this.querySelector('.p03-video__frame');
    this.poster = this.querySelector('.p03-video__poster');
    this.playButton = this.querySelector('[data-p03-play]');
    this.retryButton = this.querySelector('[data-p03-retry]');
    this.playLabel = this.playButton.dataset.playLabel || this.playButton.textContent;
    this.loadingLabel = this.playButton.dataset.loadingLabel;
    this.status = this.querySelector('[data-p03-media-status]');
    this.sources = [...this.video.querySelectorAll('source[data-p03-src]')];
    this.mobileQuery = window.matchMedia('(max-width: 749px)');
    this.video.muted = true;
    this.pauseButton = this.querySelector('[data-p03-pause]');
    this.resetToPoster();
    this.pauseButton.addEventListener('click', () => { if (this.video.paused) this.start(); else this.pause(); }, {signal});
    this.video.addEventListener('pause', () => { this.pauseButton.textContent = 'Resume'; }, {signal});
    this.video.addEventListener('ended', () => { this.pause(); this.playLabel = this.closest('p03-moment') ? 'Replay moment' : 'Say hello again'; this.resetToPoster(); }, {signal});
    this.playButton.addEventListener('click', () => this.start(), { signal });
    this.retryButton.addEventListener('click', () => this.start(true), { signal });
    this.video.addEventListener('play', () => {
      if (P03Video.active && P03Video.active !== this) P03Video.active.pause();
      P03Video.active = this;
    }, { signal });
    this.video.addEventListener('playing', () => {
      clearTimeout(this.loadingTimer);
      if (document.hidden || this.offscreen) {
        this.pause();
        return;
      }
      this.dataset.state = 'ready';
      this.pauseButton.hidden = false;
      this.pauseButton.textContent = 'Pause';
      this.frame.removeAttribute('aria-busy');
      this.video.hidden = false;
      if (this.poster) this.poster.hidden = true;
      this.playButton.hidden = true;
      this.playButton.disabled = false;
      this.status.hidden = true;
      this.retryButton.hidden = true;
      if (this.focusPlayer) this.video.focus({ preventScroll: true });
      this.focusPlayer = false;
    }, { signal });
    this.video.addEventListener('error', () => this.fail(), { signal });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.pause();
    }, { signal });
    window.addEventListener('pagehide', () => this.pause(), { signal });
    this.mobileQuery.addEventListener('change', () => {
      this.pause();
      this.clearSources();
      this.resetToPoster();
    }, { signal });
    for (const eventName of ['shopify:section:select', 'shopify:block:select']) {
      document.addEventListener(eventName, () => this.pause(), { signal });
    }
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(([entry]) => {
        this.offscreen = !entry.isIntersecting;
        if (this.offscreen) this.pause();
      }, { threshold: 0.05 });
      this.observer.observe(this);
    }
  }

  disconnectedCallback() {
    this.cleanup();
  }

  cleanup() {
    this.abort?.abort();
    this.observer?.disconnect();
    if (this.video) {
      this.pause();
      this.clearSources();
    }
    if (P03Video.active === this) P03Video.active = null;
  }

  clearSources() {
    for (const source of this.sources || []) source.removeAttribute('src');
    this.video?.removeAttribute('src');
    this.loadedOrientation = null;
    this.video?.load();
  }

  loadSources() {
    const preferred = this.mobileQuery.matches ? 'mobile' : 'desktop';
    const orientation = this.sources.some((source) => source.dataset.p03Orientation === preferred)
      ? preferred : preferred === 'mobile' ? 'desktop' : 'mobile';
    if (this.loadedOrientation === orientation) return;
    for (const source of this.sources) {
      if (source.dataset.p03Orientation === orientation) source.src = source.dataset.p03Src;
      else source.removeAttribute('src');
    }
    this.loadedOrientation = orientation;
    this.video.load();
  }

  async start(retry = false) {
    if (this.dataset.state === 'loading') return;
    this.focusPlayer = document.activeElement === this.playButton || document.activeElement === this.retryButton;
    this.dataset.state = 'loading';
    this.frame.setAttribute('aria-busy', 'true');
    this.playButton.disabled = true;
    this.playButton.textContent = this.loadingLabel;
    this.status.hidden = true;
    this.retryButton.hidden = true;
    const generation = this.generation = (this.generation || 0) + 1;
    clearTimeout(this.loadingTimer);
    this.loadingTimer = setTimeout(() => {
      if (this.isConnected && generation === this.generation) this.fail();
    }, 20000);
    try {
      if (retry) { this.clearSources(); this.video.currentTime = 0; }
      this.loadSources();
      await this.video.play();
    } catch (error) {
      if (generation !== this.generation || !this.isConnected) return;
      if (error.name === 'AbortError') this.resetToPoster();
      else this.fail();
    }
  }

  pause() {
    clearTimeout(this.loadingTimer);
    this.generation = (this.generation || 0) + 1;
    this.video?.pause();
    if (this.dataset.state === 'loading') this.resetToPoster();
    if (P03Video.active === this) P03Video.active = null;
  }

  resetToPoster() {
    this.dataset.state = 'idle';
    this.frame?.removeAttribute('aria-busy');
    if (this.video) this.video.hidden = true;
    if (this.pauseButton) this.pauseButton.hidden = true;
    if (this.poster) this.poster.hidden = false;
    if (this.playButton) {
      this.playButton.hidden = false;
      this.playButton.disabled = false;
      this.playButton.textContent = this.playLabel;
    }
    if (this.retryButton) this.retryButton.hidden = true;
    if (this.status) this.status.hidden = true;
  }

  fail() {
    const focusRetry = document.activeElement === this.video || document.activeElement === this.playButton;
    this.pause();
    this.dataset.state = 'error';
    this.frame.removeAttribute('aria-busy');
    this.video.hidden = true;
    if (this.pauseButton) this.pauseButton.hidden = true;
    if (this.poster) this.poster.hidden = false;
    this.playButton.hidden = true;
    this.playButton.disabled = false;
    this.status.hidden = false;
    this.retryButton.hidden = false;
    if (focusRetry) this.retryButton.focus({ preventScroll: true });
  }
}

if (!customElements.get('p03-video')) customElements.define('p03-video', P03Video);


class P03Gallery extends HTMLElement {
  connectedCallback() {
    this.cleanup();
    this.abort = new AbortController();
    const {signal} = this.abort;
    this.photos = this.querySelector('[data-p03-photos]');
    this.frames = [...this.querySelectorAll('[data-p03-photo]')];
    this.buttons = [...this.querySelectorAll('[data-p03-view]')];
    this.host = this.querySelector('[data-p03-model]');
    this.status = this.querySelector('[data-p03-model-status]');
    this.loadButton = this.querySelector('[data-p03-load-model]');
    this.modelControls = this.querySelector('[data-p03-model-controls]');
    this.zoom = this.querySelector('dialog');
    this.querySelector('[data-p03-choices]').hidden = false;
    this.querySelector('[data-p03-gallery-actions]').hidden = false;
    this.dataset.enhanced = '';
    this.select(this.frames[0]?.dataset.p03Photo);
    for (const button of this.buttons) button.addEventListener('click', () => { this.back(false); this.select(button.dataset.p03View); }, {signal});
    this.loadButton?.addEventListener('click', () => this.load(), {signal});
    this.querySelector('[data-p03-back]').addEventListener('click', () => this.back(true), {signal});
    this.querySelector('[data-p03-reset]').addEventListener('click', () => {
      const model = this.host.querySelector('model-viewer');
      if (!model) return;
      model.cameraOrbit = '90deg 75deg 105%'; model.cameraTarget = 'auto auto auto'; model.fieldOfView = '30deg'; model.jumpCameraToGoal?.();
      this.status.textContent = 'View reset. Drag to rotate; use arrow keys when the model is focused.';
    }, {signal});
    this.querySelector('[data-p03-zoom]').addEventListener('click', event => {
      this.zoomTrigger = event.currentTarget;
      const frame = this.frames.find(f => !f.hidden); if (!frame) return;
      const img = frame.querySelector('img');
      this.zoom.querySelector('img').src = img.currentSrc || img.src;
      this.zoom.querySelector('img').alt = img.alt;
      this.zoom.querySelector('[data-p03-zoom-caption]').textContent = frame.querySelector('figcaption').textContent;
      this.zoom.showModal();
    }, {signal});
    this.querySelector('[data-p03-close]').addEventListener('click', () => this.zoom.close(), {signal});
    this.zoom.addEventListener('close', () => this.zoomTrigger?.focus({preventScroll:true}), {signal});
    this.zoom.addEventListener('click', e => { if (e.target === this.zoom) { const b=this.zoom.getBoundingClientRect(); if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)this.zoom.close(); } }, {signal});
    document.addEventListener('shopify:block:select', e => { if(this.contains(e.target)) { const frame=e.target.closest('[data-p03-photo]'); if(frame) {this.back(false);this.select(frame.dataset.p03Photo);} } }, {signal});
    document.addEventListener('shopify:section:unload', e => { if(e.target.contains(this))this.cleanup(); }, {signal});
  }
  select(id) {
    for(const f of this.frames) f.hidden=f.dataset.p03Photo!==id;
    for(const b of this.buttons)b.setAttribute('aria-pressed',String(b.dataset.p03View===id));
  }
  back(focus) {
    this.generation=(this.generation||0)+1;clearTimeout(this.timer);
    this.host?.replaceChildren(); if(this.host)this.host.hidden=true;
    if(this.photos)this.photos.hidden=false;
    if(this.status)this.status.textContent='';
    if(this.modelControls)this.modelControls.hidden=true;
    if(this.loadButton){this.loadButton.disabled=false;this.loadButton.textContent='Explore in 3D';if(focus)this.loadButton.focus({preventScroll:true});}
    const zoomButton=this.querySelector('[data-p03-zoom]');if(zoomButton)zoomButton.hidden=false;
  }
  async load() {
    if(this.loadButton.disabled)return;
    this.back(false);
    const generation=this.generation;
    this.loadButton.disabled=true;this.loadButton.textContent='Loading 3D…';
    this.modelControls.hidden=false;this.status.textContent='Loading the 3D character. Photos remain available.';
    const fail=()=>{
      if(generation!==this.generation||!this.isConnected)return;
      this.back(false);this.status.textContent='The 3D model could not load. You can retry or use the photos.';
    };
    this.timer=setTimeout(fail,45000);
    try {
      if(!customElements.get('model-viewer')) {
        if(!P03Gallery.viewerPromise)P03Gallery.viewerPromise=new Promise((resolve,reject)=>{
          const script=document.createElement('script');script.type='module';
          script.src='https://ajax.googleapis.com/ajax/libs/model-viewer/4.3.1/model-viewer.min.js';
          const timeout=setTimeout(()=>{P03Gallery.viewerPromise=null;script.remove();reject(new Error('Viewer load timed out'));},30000);
          script.onload=()=>{clearTimeout(timeout);customElements.whenDefined('model-viewer').then(resolve);};
          script.onerror=()=>{clearTimeout(timeout);P03Gallery.viewerPromise=null;script.remove();reject(new Error('Viewer unavailable'));};
          document.head.append(script);
        });
        await P03Gallery.viewerPromise;
      }
      if(generation!==this.generation||!this.isConnected)return;
      const model=document.createElement('model-viewer');
      for(const [key,value] of Object.entries({alt:'TOMIMI character. Drag to rotate, or use arrow keys.','camera-controls':'','touch-action':'pan-y','camera-orbit':'90deg 75deg 105%','field-of-view':'30deg','interaction-prompt':'none','shadow-intensity':'0.6',loading:'eager',tabindex:'0'}))model.setAttribute(key,value);
      model.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key))return;
        event.preventDefault();event.stopPropagation();
        const orbit=model.getCameraOrbit();
        const delta=Math.PI/18;
        const theta=orbit.theta+(event.key==='ArrowRight'?delta:event.key==='ArrowLeft'?-delta:0);
        const phi=Math.max(.15,Math.min(Math.PI-.15,orbit.phi+(event.key==='ArrowDown'?delta:event.key==='ArrowUp'?-delta:0)));
        model.cameraOrbit=theta+'rad '+phi+'rad '+orbit.radius+'m';model.jumpCameraToGoal();
      },{signal:this.abort.signal,capture:true});
      model.addEventListener('load',()=>{
        if(generation!==this.generation)return;
        clearTimeout(this.timer);this.host.hidden=false;this.photos.hidden=true;
        this.querySelector('[data-p03-zoom]').hidden=true;
        this.loadButton.textContent='3D view open';this.status.textContent='Drag to rotate · Scroll or pinch to zoom · Arrow keys also rotate';
        model.focus({preventScroll:true});
      },{signal:this.abort.signal,once:true});
      model.addEventListener('error',fail,{signal:this.abort.signal,once:true});
      this.host.append(model);model.src=this.dataset.modelUrl;
    }catch{fail();}
  }
  cleanup(){this.abort?.abort();this.back(false);this.zoom?.close();}
  disconnectedCallback(){this.cleanup();}
}

class P03Moment extends HTMLElement {
  connectedCallback(){
    this.abort?.abort();this.abort=new AbortController();const{signal}=this.abort;
    this.querySelector('[data-p03-scenes]').hidden=false;
    const caption=this.querySelector('[data-p03-scene-copy]');
    for(const button of this.querySelectorAll('[data-p03-scene]'))button.addEventListener('click',()=>{
      const scene=button.dataset.p03Scene;this.dataset.scene=scene;
      this.querySelectorAll('[data-p03-scene]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      caption.textContent=caption.dataset[scene];
      const player=this.querySelector('p03-video');
      if(scene==='quiet'){player.pause?.();player.resetToPoster?.();}
      else if(!matchMedia('(prefers-reduced-motion: reduce)').matches)player.start?.(true);
    },{signal});
  }
  disconnectedCallback(){this.abort?.abort();}
}

function p03SyncPrice(){
  const card=document.querySelector('.p03-purchase p01-product-card');
  const price=card?.querySelector('[data-p01-price]');
  if(!price)return;
  document.querySelectorAll('[data-p03-price]').forEach(node=>node.textContent=price.textContent);
}
document.addEventListener('change',event=>{
  if(!event.target.matches('.p03-purchase [data-p01-variant]'))return;
  queueMicrotask(()=>{
    p03SyncPrice();const url=new URL(location.href);url.searchParams.set('variant',event.target.value);history.replaceState({},'',url);
  });
});
document.addEventListener('shopify:section:load',()=>requestAnimationFrame(p03SyncPrice));
if(!customElements.get('p03-gallery'))customElements.define('p03-gallery',P03Gallery);
if(!customElements.get('p03-moment'))customElements.define('p03-moment',P03Moment);
p03SyncPrice();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p04-hello"] && !Shopify.designMode) return;
  try {
    
class P04Video extends HTMLElement {
  static active = null;

  connectedCallback() {
    this.cleanup();
    this.video = this.querySelector('video');
    if (!this.video) return;
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.frame = this.querySelector('.p04-video__frame');
    this.poster = this.querySelector('.p04-video__poster');
    this.playButton = this.querySelector('[data-p04-play]');
    this.retryButton = this.querySelector('[data-p04-retry]');
    this.playLabel = this.playButton.dataset.playLabel || this.playButton.textContent;
    this.loadingLabel = this.playButton.dataset.loadingLabel;
    this.status = this.querySelector('[data-p04-media-status]');
    this.sources = [...this.video.querySelectorAll('source[data-p04-src]')];
    this.mobileQuery = window.matchMedia('(max-width: 749px)');
    this.video.muted = true;
    this.pauseButton = this.querySelector('[data-p04-pause]');
    this.resetToPoster();
    this.pauseButton.addEventListener('click', () => { if (this.video.paused) this.start(); else this.pause(); }, {signal});
    this.video.addEventListener('pause', () => { this.pauseButton.textContent = 'Resume'; }, {signal});
    this.video.addEventListener('ended', () => { this.pause(); this.playLabel = this.closest('p04-moment') ? 'Play this moment again' : 'Say hello again'; this.resetToPoster(); }, {signal});
    this.playButton.addEventListener('click', () => this.start(), { signal });
    this.retryButton.addEventListener('click', () => this.start(true), { signal });
    this.video.addEventListener('play', () => {
      if (P04Video.active && P04Video.active !== this) P04Video.active.pause();
      P04Video.active = this;
    }, { signal });
    this.video.addEventListener('playing', () => {
      clearTimeout(this.loadingTimer);
      if (document.hidden || this.offscreen) {
        this.pause();
        return;
      }
      this.dataset.state = 'ready';
      this.pauseButton.hidden = false;
      this.pauseButton.textContent = this.closest('p04-moment') ? 'Pause this moment' : 'Pause';
      this.frame.removeAttribute('aria-busy');
      this.video.hidden = false;
      if (this.poster) this.poster.hidden = true;
      this.playButton.hidden = true;
      this.playButton.disabled = false;
      this.status.hidden = true;
      this.retryButton.hidden = true;
      if (this.focusPlayer) this.video.focus({ preventScroll: true });
      this.focusPlayer = false;
    }, { signal });
    this.video.addEventListener('error', () => this.fail(), { signal });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.pause();
    }, { signal });
    window.addEventListener('pagehide', () => this.pause(), { signal });
    this.mobileQuery.addEventListener('change', () => {
      this.pause();
      this.clearSources();
      this.resetToPoster();
    }, { signal });
    for (const eventName of ['shopify:section:select', 'shopify:block:select']) {
      document.addEventListener(eventName, () => this.pause(), { signal });
    }
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(([entry]) => {
        this.offscreen = !entry.isIntersecting;
        if (this.offscreen) this.pause();
      }, { threshold: 0.05 });
      this.observer.observe(this);
    }
  }

  disconnectedCallback() {
    this.cleanup();
  }

  cleanup() {
    this.abort?.abort();
    this.observer?.disconnect();
    if (this.video) {
      this.pause();
      this.clearSources();
    }
    if (P04Video.active === this) P04Video.active = null;
  }

  clearSources() {
    for (const source of this.sources || []) source.removeAttribute('src');
    this.video?.removeAttribute('src');
    this.loadedOrientation = null;
    this.video?.load();
  }

  loadSources() {
    const preferred = this.mobileQuery.matches ? 'mobile' : 'desktop';
    const orientation = this.sources.some((source) => source.dataset.p04Orientation === preferred)
      ? preferred : preferred === 'mobile' ? 'desktop' : 'mobile';
    if (this.loadedOrientation === orientation) return;
    for (const source of this.sources) {
      if (source.dataset.p04Orientation === orientation) source.src = source.dataset.p04Src;
      else source.removeAttribute('src');
    }
    this.loadedOrientation = orientation;
    this.video.load();
  }

  async start(retry = false) {
    if (this.dataset.state === 'loading') return;
    this.focusPlayer = document.activeElement === this.playButton || document.activeElement === this.retryButton;
    this.dataset.state = 'loading';
    this.frame.setAttribute('aria-busy', 'true');
    this.playButton.disabled = true;
    this.playButton.textContent = this.loadingLabel;
    this.status.hidden = true;
    this.retryButton.hidden = true;
    const generation = this.generation = (this.generation || 0) + 1;
    clearTimeout(this.loadingTimer);
    this.loadingTimer = setTimeout(() => {
      if (this.isConnected && generation === this.generation) this.fail();
    }, 20000);
    try {
      if (retry) { this.clearSources(); this.video.currentTime = 0; }
      this.loadSources();
      await this.video.play();
    } catch (error) {
      if (generation !== this.generation || !this.isConnected) return;
      if (error.name === 'AbortError') this.resetToPoster();
      else this.fail();
    }
  }

  pause() {
    clearTimeout(this.loadingTimer);
    this.generation = (this.generation || 0) + 1;
    this.video?.pause();
    if (this.dataset.state === 'loading') this.resetToPoster();
    if (P04Video.active === this) P04Video.active = null;
  }

  resetToPoster() {
    this.dataset.state = 'idle';
    this.frame?.removeAttribute('aria-busy');
    if (this.video) this.video.hidden = true;
    if (this.pauseButton) this.pauseButton.hidden = true;
    if (this.poster) this.poster.hidden = false;
    if (this.playButton) {
      this.playButton.hidden = false;
      this.playButton.disabled = false;
      this.playButton.textContent = this.playLabel;
    }
    if (this.retryButton) this.retryButton.hidden = true;
    if (this.status) this.status.hidden = true;
  }

  fail() {
    const focusRetry = document.activeElement === this.video || document.activeElement === this.playButton;
    this.pause();
    this.dataset.state = 'error';
    this.frame.removeAttribute('aria-busy');
    this.video.hidden = true;
    if (this.pauseButton) this.pauseButton.hidden = true;
    if (this.poster) this.poster.hidden = false;
    this.playButton.hidden = true;
    this.playButton.disabled = false;
    this.status.hidden = false;
    this.retryButton.hidden = false;
    if (focusRetry) this.retryButton.focus({ preventScroll: true });
  }
}

if (!customElements.get('p04-video')) customElements.define('p04-video', P04Video);


class P04Gallery extends HTMLElement {
  connectedCallback() {
    this.cleanup();
    this.abort = new AbortController();
    const {signal} = this.abort;
    this.photos = this.querySelector('[data-p04-photos]');
    this.frames = [...this.querySelectorAll('[data-p04-photo]')];
    this.buttons = [...this.querySelectorAll('[data-p04-view]')];
    this.host = this.querySelector('[data-p04-model]');
    this.status = this.querySelector('[data-p04-model-status]');
    this.loadButton = this.querySelector('[data-p04-load-model]');
    this.modelControls = this.querySelector('[data-p04-model-controls]');
    this.zoom = this.querySelector('dialog');
    this.querySelector('[data-p04-choices]').hidden = false;
    this.querySelector('[data-p04-gallery-actions]').hidden = false;
    this.dataset.enhanced = '';
    this.select(this.frames[0]?.dataset.p04Photo);
    for (const button of this.buttons) button.addEventListener('click', () => { this.back(false); this.select(button.dataset.p04View); }, {signal});
    this.loadButton?.addEventListener('click', () => this.load(), {signal});
    this.querySelector('[data-p04-back]').addEventListener('click', () => this.back(true), {signal});
    this.querySelector('[data-p04-reset]').addEventListener('click', () => {
      const model = this.host.querySelector('model-viewer');
      if (!model) return;
      model.cameraOrbit = '90deg 75deg 105%'; model.cameraTarget = 'auto auto auto'; model.fieldOfView = '30deg'; model.jumpCameraToGoal?.();
      this.status.textContent = 'View reset. Drag to rotate; use arrow keys when the model is focused.';
    }, {signal});
    this.querySelector('[data-p04-zoom]').addEventListener('click', event => {
      this.zoomTrigger = event.currentTarget;
      const frame = this.frames.find(f => !f.hidden); if (!frame) return;
      const img = frame.querySelector('img');
      this.zoom.querySelector('img').src = img.currentSrc || img.src;
      this.zoom.querySelector('img').alt = img.alt;
      this.zoom.querySelector('[data-p04-zoom-caption]').textContent = frame.querySelector('figcaption').textContent;
      this.zoom.showModal();
    }, {signal});
    this.querySelector('[data-p04-close]').addEventListener('click', () => this.zoom.close(), {signal});
    this.zoom.addEventListener('close', () => this.zoomTrigger?.focus({preventScroll:true}), {signal});
    this.zoom.addEventListener('click', e => { if (e.target === this.zoom) { const b=this.zoom.getBoundingClientRect(); if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)this.zoom.close(); } }, {signal});
    document.addEventListener('shopify:block:select', e => { if(this.contains(e.target)) { const frame=e.target.closest('[data-p04-photo]'); if(frame) {this.back(false);this.select(frame.dataset.p04Photo);} } }, {signal});
    document.addEventListener('shopify:section:unload', e => { if(e.target.contains(this))this.cleanup(); }, {signal});
  }
  select(id) {
    for(const f of this.frames) f.hidden=f.dataset.p04Photo!==id;
    for(const b of this.buttons)b.setAttribute('aria-pressed',String(b.dataset.p04View===id));
  }
  back(focus) {
    this.generation=(this.generation||0)+1;clearTimeout(this.timer);
    this.host?.replaceChildren(); if(this.host)this.host.hidden=true;
    if(this.photos)this.photos.hidden=false;
    if(this.status)this.status.textContent='';
    if(this.modelControls)this.modelControls.hidden=true;
    if(this.loadButton){this.loadButton.disabled=false;this.loadButton.textContent='Explore in 3D';if(focus)this.loadButton.focus({preventScroll:true});}
    const zoomButton=this.querySelector('[data-p04-zoom]');if(zoomButton)zoomButton.hidden=false;
  }
  async load() {
    if(this.loadButton.disabled)return;
    this.back(false);
    const generation=this.generation;
    this.loadButton.disabled=true;this.loadButton.textContent='Loading 3D…';
    this.modelControls.hidden=false;this.status.textContent='Loading the 3D character. Photos remain available.';
    const fail=()=>{
      if(generation!==this.generation||!this.isConnected)return;
      this.back(false);this.status.textContent='The 3D model could not load. You can retry or use the photos.';
    };
    this.timer=setTimeout(fail,45000);
    try {
      if(!customElements.get('model-viewer')) {
        if(!P04Gallery.viewerPromise)P04Gallery.viewerPromise=new Promise((resolve,reject)=>{
          const script=document.createElement('script');script.type='module';
          script.src='https://ajax.googleapis.com/ajax/libs/model-viewer/4.3.1/model-viewer.min.js';
          const timeout=setTimeout(()=>{P04Gallery.viewerPromise=null;script.remove();reject(new Error('Viewer load timed out'));},30000);
          script.onload=()=>{clearTimeout(timeout);customElements.whenDefined('model-viewer').then(resolve);};
          script.onerror=()=>{clearTimeout(timeout);P04Gallery.viewerPromise=null;script.remove();reject(new Error('Viewer unavailable'));};
          document.head.append(script);
        });
        await P04Gallery.viewerPromise;
      }
      if(generation!==this.generation||!this.isConnected)return;
      const model=document.createElement('model-viewer');
      for(const [key,value] of Object.entries({alt:'MILOLO character. Drag to rotate, or use arrow keys.','camera-controls':'','touch-action':'pan-y','camera-orbit':'90deg 75deg 105%','field-of-view':'30deg','interaction-prompt':'none','shadow-intensity':'0.6',loading:'eager',tabindex:'0'}))model.setAttribute(key,value);
      model.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key))return;
        event.preventDefault();event.stopPropagation();
        const orbit=model.getCameraOrbit();
        const delta=Math.PI/18;
        const theta=orbit.theta+(event.key==='ArrowRight'?delta:event.key==='ArrowLeft'?-delta:0);
        const phi=Math.max(.15,Math.min(Math.PI-.15,orbit.phi+(event.key==='ArrowDown'?delta:event.key==='ArrowUp'?-delta:0)));
        model.cameraOrbit=theta+'rad '+phi+'rad '+orbit.radius+'m';model.jumpCameraToGoal();
      },{signal:this.abort.signal,capture:true});
      model.addEventListener('load',()=>{
        if(generation!==this.generation)return;
        clearTimeout(this.timer);this.host.hidden=false;this.photos.hidden=true;
        this.querySelector('[data-p04-zoom]').hidden=true;
        this.loadButton.textContent='3D view open';this.status.textContent='Drag to rotate · Scroll or pinch to zoom · Arrow keys also rotate';
        model.focus({preventScroll:true});
      },{signal:this.abort.signal,once:true});
      model.addEventListener('error',fail,{signal:this.abort.signal,once:true});
      this.host.append(model);model.src=this.dataset.modelUrl;
    }catch{fail();}
  }
  cleanup(){this.abort?.abort();this.back(false);this.zoom?.close();}
  disconnectedCallback(){this.cleanup();}
}

class P04Moment extends HTMLElement {
  connectedCallback(){
    this.abort?.abort();this.abort=new AbortController();const {signal}=this.abort;
    const player=this.querySelector('p04-video'), video=player.querySelector('video');
    const caption=this.querySelector('[data-p04-scene-copy]');
    const reset=this.querySelector('[data-p04-still]');reset.hidden=false;
    reset.addEventListener('click',()=>{player.pause?.();video.currentTime=0;player.resetToPoster?.();caption.textContent=caption.dataset.quiet;},{signal});
    video.addEventListener('playing',()=>{caption.textContent=caption.dataset.playing;},{signal});
    video.addEventListener('ended',()=>{caption.textContent=caption.dataset.quiet;},{signal});
    video.addEventListener('error',()=>{caption.textContent=caption.dataset.quiet;},{signal});
  }
  disconnectedCallback(){this.abort?.abort();}
}

function p04SyncPrice(){
  const card=document.querySelector('.p04-purchase p01-product-card');
  const price=card?.querySelector('[data-p01-price]');
  if(!price)return;
  document.querySelectorAll('[data-p04-price]').forEach(node=>node.textContent=price.textContent);
}
document.addEventListener('change',event=>{
  if(!event.target.matches('.p04-purchase [data-p01-variant]'))return;
  queueMicrotask(()=>{
    p04SyncPrice();const url=new URL(location.href);url.searchParams.set('variant',event.target.value);history.replaceState({},'',url);
  });
});
document.addEventListener('shopify:section:load',()=>requestAnimationFrame(p04SyncPrice));
if(!customElements.get('p04-gallery'))customElements.define('p04-gallery',P04Gallery);
if(!customElements.get('p04-moment'))customElements.define('p04-moment',P04Moment);
p04SyncPrice();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p05-cart"] && !Shopify.designMode) return;
  try {
    
class P05Cart extends HTMLElement {
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const {signal}=this.abort;
  this.dataset.enhanced='';this.pending=false;this.uncertain=false;this.intent=null;this.external=Promise.resolve();
  this.enhance();
  this.addEventListener('click',e=>this.click(e),{signal});
  this.addEventListener('input',e=>{if(e.target.matches('[data-quantity]')){e.target.setCustomValidity('');this.queue(e.target);}}, {signal});
  this.addEventListener('submit',e=>{if(this.pending||this.intent||this.uncertain){e.preventDefault();return;}if(e.submitter?.name==='update')e.preventDefault();},{signal});
  import('@shopify/events').then(api=>{if(signal.aborted)return;this.api=api;document.addEventListener(api.StandardEvents.cartLinesUpdate,e=>{if(e.target===this)return;this.external=e.promise||Promise.resolve();this.lock(true);this.external.then(()=>this.refresh()).catch(()=>this.fail()).finally(()=>{if(!this.pending&&!this.uncertain)this.lock(false);});},{signal});});
  window.addEventListener('pageshow',e=>{if(e.persisted)this.refresh().catch(()=>this.fail());},{signal});
 }
 disconnectedCallback(){this.abort?.abort();clearTimeout(this.timer);}
 enhance(){this.querySelectorAll('[data-step]').forEach(b=>b.hidden=false);}
 row(key){return [...this.querySelectorAll('[data-key]')].find(x=>x.dataset.key===key);}
 click(e){
  const step=e.target.closest('[data-step]'),remove=e.target.closest('[data-remove]');
  if(step){const input=step.closest('[data-key]').querySelector('[data-quantity]');input.value=Number(input.value)+Number(step.dataset.step)*Number(input.step||1);this.queue(input);}
  if(remove){e.preventDefault();if(this.pending||this.uncertain)return;const row=remove.closest('[data-key]');this.intent={key:row.dataset.key,quantity:0};this.focus={key:row.dataset.key,control:'remove',index:[...this.querySelectorAll('[data-key]')].indexOf(row)};this.lock(true);this.drain();}
  if(e.target.closest('[data-retry]')){this.lock(true);this.refresh().then(()=>{this.uncertain=false;this.querySelector('[data-recovery]').hidden=true;this.lock(false);}).catch(()=>this.fail());}
 }
 queue(input){
  const row=input.closest('[data-key]');if(this.uncertain)return;
  const n=Number(input.value),min=Number(input.min||1),step=Number(input.step||1),max=input.max?Number(input.max):Infinity;
  clearTimeout(this.timer);
  if(input.value===''||!Number.isSafeInteger(n)||n<min||n>max||(n-min)%step!==0){input.setCustomValidity(this.dataset.invalid);row.querySelector('[data-line-error]').textContent=this.dataset.invalid;this.intent=null;this.invalid=true;this.lock(true,row.dataset.key);return;}
  this.invalid=false;input.setCustomValidity('');row.querySelector('[data-line-error]').textContent='';
  this.intent={key:row.dataset.key,quantity:n};this.lastRequested=n;this.focus={key:row.dataset.key,control:document.activeElement?.dataset.focus||'quantity',index:[...this.querySelectorAll('[data-key]')].indexOf(row)};
  this.lock(true,row.dataset.key);this.timer=setTimeout(()=>this.drain(),280);
 }
 lock(busy,activeKey){
  this.querySelectorAll('[data-checkout]').forEach(b=>b.disabled=busy||this.uncertain||this.invalid||b.hasAttribute('data-blocked'));
  this.querySelectorAll('[data-key]').forEach(row=>{const other=busy&&row.dataset.key!==activeKey;row.querySelectorAll('[data-step]').forEach(b=>b.disabled=other);row.querySelector('[data-quantity]').readOnly=other;});
  this.setAttribute('aria-busy',String(busy));
 }
 async json(url,options={}){const r=await fetch(url,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(20000),...options});const d=await r.json();if(!r.ok){const e=new Error(d.description||d.message||this.dataset.error);e.rejected=r.status>=400&&r.status<500;throw e;}return d;}
 async drain(){
  if(this.pending||this.uncertain||!this.intent||!this.isConnected)return;
  const life=this.abort.signal;this.pending=true;this.querySelector('[data-status]').textContent=this.dataset.updating;
  try{
   await this.external;
   while(this.intent&&this.isConnected&&!life.aborted){
    const next=this.intent;this.intent=null;this.lock(true,next.key);
    const sections=[this.dataset.sectionId,...document.querySelectorAll('cart-items-component[data-section-id]')].map(x=>typeof x==='string'?x:x.dataset.sectionId);
    const data=await this.json(this.dataset.changeUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:next.key,quantity:next.quantity,sections:[...new Set(sections)].slice(0,5),sections_url:location.pathname})});
    if(!this.isConnected||life.aborted)return;
    const current=data.items.find(x=>x.key===next.key);
    if(this.intent&&current&&current.quantity===this.intent.quantity)this.intent=null;
    if(this.intent&&!current){this.intent=null;await this.refresh();throw new Error(this.dataset.error);}
    if(!this.intent){await this.render(data.sections?.[this.dataset.sectionId]);this.publish(data);}
   }
   if(this.isConnected&&!life.aborted){this.querySelector('[data-status]').textContent=this.dataset.updated;this.restoreFocus();}
  }catch(error){
   this.intent=null;
   if(this.isConnected&&!life.aborted){this.fail();const row=this.row(this.focus?.key);if(row){row.querySelector('[data-quantity]').value=row.dataset.confirmed;row.querySelector('[data-line-error]').textContent=(error.rejected?error.message:this.dataset.error)+(this.lastRequested ? ' '+this.dataset.requested.replace('[quantity]',this.lastRequested):'');}this.querySelector('[data-status]').textContent='';}
  }finally{if(!life.aborted){this.pending=false;if(this.isConnected&&!this.uncertain)this.lock(false);}}
 }
 async render(html){
  if(!html){const url=new URL(location.href);url.searchParams.set('section_id',this.dataset.sectionId);const r=await fetch(url,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(20000)});if(!r.ok)throw Error(this.dataset.error);html=await r.text();}
  const fresh=new DOMParser().parseFromString(html,'text/html').querySelector('p05-cart [data-cart-content]');if(!fresh)throw Error(this.dataset.error);
  if(!this.isConnected)return;this.querySelector('[data-cart-content]').replaceChildren(...fresh.childNodes);this.enhance();
 }
 async refresh(){await this.render();const data=await this.json(this.dataset.cartUrl+'.js');this.publish(data);this.invalid=false;}
 publish(data){if(this.api)this.dispatchEvent(new this.api.CartLinesUpdateEvent({action:'update',context:'cart',lines:[],promise:Promise.resolve({cart:this.api.CartLinesUpdateEvent.createCartFromAjaxResponse(data),detail:{items:data.items,itemCount:data.item_count,sections:data.sections,source:'p05-cart'}})}));}
 restoreFocus(){const f=this.focus;if(!f)return;const rows=[...this.querySelectorAll('[data-key]')];const row=this.row(f.key)||rows[Math.min(f.index,rows.length-1)];const target=row?.querySelector(`[data-focus="${f.control}"]`)||row?.querySelector('[data-quantity]')||this.querySelector('h1');target?.focus({preventScroll:true});}
 fail(){this.uncertain=true;this.querySelector('[data-recovery]').hidden=false;this.lock(true);}
}
if(!customElements.get('p05-cart'))customElements.define('p05-cart',P05Cart);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p09-article-body"]) return;
  try {
    
if (!customElements.get('p09-content')) {
  customElements.define('p09-content', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const prose = this.querySelector('[data-p09-prose]');
      if (!prose) return;
      prose.querySelectorAll('table').forEach(table => {
        if (table.parentElement.classList.contains('p09-table-scroll')) return;
        const wrap = document.createElement('div');
        wrap.className = 'p09-table-scroll';
        wrap.tabIndex = 0; wrap.setAttribute('role', 'region');
        wrap.setAttribute('aria-label', this.dataset.tableLabel);
        table.before(wrap); wrap.append(table);
      });
      const headings = [...prose.querySelectorAll('h2')];
      const toc = this.querySelector('.p09-toc');
      const list = toc.querySelector('ol');
      list.replaceChildren();
      const words = prose.textContent.trim().split(/\s+/).length;
      const enabled = this.dataset.toc === 'true' && headings.length >= 4 && words >= 1200;
      toc.hidden = !enabled; this.classList.toggle('p09-reading--toc', enabled);
      if (!enabled) return;
      headings.forEach((heading, index) => {
        if (!heading.id || document.querySelectorAll(`[id="${CSS.escape(heading.id)}"]`).length > 1) {
          const stem = 'p09-' + (heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section');
          let id = `${stem}-${index + 1}`, suffix = 1;
          while (document.getElementById(id)) id = `${stem}-${index + 1}-${suffix++}`;
          heading.id = id;
        }
        heading.tabIndex = -1;
        const li = document.createElement('li'), a = document.createElement('a');
        a.href = '#' + encodeURIComponent(heading.id); a.textContent = heading.textContent;
        a.addEventListener('click', () => heading.focus({preventScroll:true}), {signal:this.controller.signal});
        li.append(a); list.append(li);
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p09-article-head"]) return;
  try {
    
if (!customElements.get('p09-share')) {
  customElements.define('p09-share', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const button = this.querySelector('button');
      button.hidden = false;
      button.addEventListener('click', async () => {
        const status = this.querySelector('[role="status"]');
        const fallback = this.querySelector('label');
        button.disabled = true;
        status.textContent = '';
        fallback.hidden = true;
        try {
          const url = new URL(this.dataset.url);
          url.search = ''; url.hash = '';
          if (!['https:', 'http:'].includes(url.protocol)) throw new Error('Invalid URL');
          await navigator.clipboard.writeText(url.href);
          if (this.isConnected) status.textContent = this.dataset.success;
        } catch {
          if (!this.isConnected) return;
          status.textContent = this.dataset.failure;
          fallback.hidden = false;
          const input = fallback.querySelector('input');
          input.focus(); input.select();
        } finally { button.disabled = false; }
      }, {signal: this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-journal-stories"] && !Shopify.designMode) return;
  try {
    
function initSmilellemonJournal(root=document){
 root.querySelectorAll('[data-story-open]').forEach(link=>{if(link.dataset.ready)return;link.dataset.ready='true';link.addEventListener('click',event=>{const dialog=document.getElementById(link.dataset.storyOpen);if(!dialog)return;event.preventDefault();dialog.showModal();history.replaceState(null,'','#'+dialog.id);});});
 root.querySelectorAll('.sm-story-dialog').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';dialog.querySelector('[data-story-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>{if(location.hash==='#'+dialog.id)history.replaceState(null,'',location.pathname+location.search);});});
 const hash=decodeURIComponent(location.hash.slice(1));const target=document.getElementById(hash);if(target?.classList.contains('sm-story-dialog')&&!target.open)target.showModal();
}
initSmilellemonJournal();document.addEventListener('shopify:section:load',event=>initSmilellemonJournal(event.target));

  } catch(e) { console.error(e); }
})();
})();
